<template>
  <span
    :class="[defaultClass, name, `${classPrefix}-${name}`, splitClass]"
    :style="{ fontSize: fontSizeVal, color, opacity }"
    @click="handlerCallback"
    @mouseover="handlerMouseover"
    @mouseout="handlerMouseout"
  ></span>
</template>
<script>
  import { mapState } from 'vuex'
  export default {
    props: {
      defaultClass: {
        type: String,
        default: 'iconfont',
      },

      classNames: [String, Array],
      // 图标名称
      name: {
        type: String,
        default: '',
        required: true,
      },
      // 图标颜色
      color: {
        type: String,
        default: '#000',
      },
      // 图标大小
      size: {
        type: [Number, String],
        default: 16,
      },
      opacity: {
        type: Number,
        default: 1,
      },
      // 类名前缀，用于使用自定义图标
      classPrefix: {
        type: String,
        default: 'mb',
      },
    },
    data() {
      return {
        fontSizeVal: '',
      }
    },
    computed: {
      ...mapState(['isDesktop']),
      comFontSize() {
        const toVw = ((this.size / 1080) * 100).toFixed(2)
        return {
          isDesktop: this.isDesktop,
          msize: +toVw + 'vw',
          psize: `${this.size}px`,
        }
      },
      splitClass() {
        if (Array.isArray(this.classNames)) {
          return this.classNames.join(' ')
        }
        return this.classNames
      },
    },

    watch: {
      comFontSize: {
        handler(newVal) {
          const { isDesktop, msize, psize } = newVal
          this.fontSizeVal = isDesktop ? psize : msize
        },
        deep: true,
        immediate: true,
      },
    },

    mounted() {},
    methods: {
      handlerCallback(event) {
        this.$emit('click', event)
      },
      handlerMouseover(event) {
        this.$emit('mouseover', event)
      },
      handlerMouseout(event) {
        this.$emit('mouseout', event)
      },
    },
  }
</script>

<style scoped lang="scss">
  .iconfont {
    cursor: pointer;
  }
</style>
